<template lang="pug">
    .landingpage
        .header-area(v-if="areas.header && areas.header.length")
            section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key" v-if="index === 0")
                Banner(v-if="section.key === 'banner'" :section="section")
            section(v-for="(section, index) in areas.main" :key="section.id" :class="section.key")
                Heading(
                    v-if="section.key === 'heading'" :section="section"
                    heading-class="is-size-2-desktop is-size-3-tablet is-size-4-mobile"
                    sub-heading-class="is-size-6 is-uppercase has-text-primary"
                )
                CategoryPosts(
                    v-if="section.key === 'categoryposts'"
                    :section="section"
                    :per-page="12"
                    orientation="horizontal"
                )
                ImageSection(v-if="section.key === 'image'" :section="section")
                Post(v-if="section.key === 'post'" :section="section")
        .footer-area(v-if="areas.footer && areas.footer.length")
            section(v-for="(section, index) in areas.footer" :key="section.id" :class="section.key" v-if="index === 0")
                Post(v-if="section.key === 'post'" :section="section")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import CategoryPosts from '@/components/CategoryPosts'
import Post from '@/components/Post'
import Banner from '@/components/Banner'

export default {
    name: 'LandingPage',
    components: {
        Heading,
        ImageSection,
        CategoryPosts,
        Post,
        Banner    
    },
    computed: {
        areas() {
            let areas = {};
            this.sections.map( section => {
                const key = section.area || 'main';
                if ( !areas[key] ) areas[key] = [];
                areas[key].push(section)
            } );
            return areas;
        },
        ...mapGetters('currentPage', {
            sections: 'sections',
        })
    }
}

</script>

<style lang="sass" scoped>
    @import '~@/assets/sass/variables'
    .section.slider,
    .section.banner, .section.videostreaming
        padding: 0
    .section.heading
        padding-bottom: 0
    .footer-area
        background-color: #2f2f2f
        position: absolute
        width: 100%
        bottom: 0
        padding: 75px 0
        &::v-deep .post 
            color: #fff!important
    .header-area, .main-area
        margin-bottom: 35px
</style>
